import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../style/LoginForm.css';

const LoginForm = () => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/dashboard'); // Redirect to dashboard if token exists
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (phone === '' || password === '') {
            setError('Заполните все поля');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post('https://api.alertapp.kz/api/v1/auth/login', {
                phone,
                password
            });
            console.log('Server response:', response.data);
            localStorage.setItem('token', response.data.accessToken);
            navigate('/dashboard');
            window.location.reload();
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                setError(err.response.data.message);
            } else {
                setError('Ошибка сервера');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                <h2>Авторизация</h2>
                <input
                    type="text"
                    placeholder="Телефон"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className={`input-field ${error ? 'error-border' : ''}`}
                />
                <input
                    type="password"
                    placeholder="Пароль"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`input-field ${error ? 'error-border' : ''}`}
                />
                {error && <p className="error-text">{error}</p>}
                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Загрузка...' : 'Войти'}
                </button>
            </form>
        </div>
    );
}

export default LoginForm;
